// eslint-disable-next-line no-shadow
export enum ErrorType {
  None = 'None',
  Add = 'Add',
  Delete = 'Delete',
  Update = 'Update',
  Load = 'Load',
  EmptyInput = 'EmptyInput',
}
